module.exports = __webpack_public_path__ + "static/media/logo.d7ca0741.png";